import routes from 'config/routes'
import { fetch } from 'utils/fetch'

type FetcherResult =
  | { ok: true; data: Record<string, unknown> }
  | { ok: false; code: string; retryable: boolean; message: string }

async function fetchCmsEntry(contentType: string, pageUrl: string): Promise<FetcherResult> {
  try {
    // We pass `useMenuService = true` for two reasons unrelated to the menu
    // service: it tells `utils/fetch` to (a) skip the snake_case→camelCase
    // mutation in JSONParse so ContentStack uids reach `BLOCK_REGISTRY`
    // unchanged, and (b) read the response from the `{ data }` envelope our
    // Koa /cms/entry route returns. Naming is misleading but it's the existing
    // escape hatch — revisit when we stop using the utils/fetch complex for CMS requests.
    const response = (await fetch(
      null,
      routes.cms.entry,
      { contentType, pageUrl },
      'GET',
      'default',
      {},
      null,
      false,
      true,
    )) as { data?: Record<string, unknown> } | null

    if (response?.data) {
      return { ok: true, data: response.data }
    }

    return {
      ok: false,
      code: 'BAD_RESPONSE',
      retryable: false,
      message: 'CMS response missing data',
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown error'

    return { ok: false, code: 'NETWORK', retryable: true, message }
  }
}

export { fetchCmsEntry }
